export default {
  "nav.spreadsheet": "CSSBuy Spreadsheet",
  "nav.categories": "Kategorien",
  "nav.guides": "Ratgeber",
  "nav.reviews": "Reviews",
  "nav.shipping": "Versand",
  "nav.qc": "QC",
  "nav.safety": "Sicherheit",
  "nav.faq": "FAQ",
  "nav.about": "Über uns",
  "nav.contact": "Kontakt",
  "nav.article": "Artikel",
  "nav.home": "Startseite",
  "nav.guide": "Kaufratgeber",
  "lang.en": "Englisch",
  "lang.pt": "Portugiesisch",
  "lang.de": "Deutsch",
  "hero.eyebrow": "UNABHÄNGIGER RATGEBER • AKTUALISIERT • EINFACHE SUCHE",
  "hero.title": "CSSBuy Spreadsheet – Produkte finden, vergleichen und übersichtlich recherchieren",
  "hero.subtitle": "Entdecke organisierte Produktlinks, Kategorien, Einkaufsratgeber, QC-Informationen und Versandressourcen für eine einfachere CSSBuy-Recherche.",
  "hero.cta_primary": "CSSBuy Spreadsheet öffnen",
  "hero.cta_secondary": "Kategorien ansehen",
  "hero.trust": "Unabhängiger Ratgeber • Strukturierte Informationen • Externe Links klar gekennzeichnet",
  "cta.main_site": "CSSBuy Spreadsheet",
  "cta.buy_now": "Buy It Now",
  "categories.title": "Beliebte Kategorien erkunden",
  "categories.subtitle": "Finde schnell die Produkte, die du recherchieren möchtest",
  "what.title": "Was ist ein CSSBuy Spreadsheet?",
  "what.description": "Ein CSSBuy Spreadsheet ist eine praktische Möglichkeit, Produkte, Links und Rechercheinformationen an einem Ort zu organisieren. Du kannst Kategorien durchsuchen, Informationen vergleichen und Ratgeber konsultieren, bevor du eine Entscheidung triffst.",
  "what.warning": "Preise, Verfügbarkeit, Verkäufer, Links und Versandinformationen können sich ändern. Bestätige immer aktuelle Daten vor dem Kauf.",
  "what.cta": "Spreadsheet erkunden",
  "how.title": "So verwendest du CSSBuy Spreadsheet",
  "how.step1_title": "Wähle eine Kategorie",
  "how.step1_desc": "Finde den Produkttyp, den du recherchieren möchtest.",
  "how.step2_title": "Vergleiche Informationen",
  "how.step2_desc": "Prüfe Links, Preise, Größen, QC, Verkäufer und Verfügbarkeit.",
  "how.step3_title": "Mache deine Verifizierung",
  "how.step3_desc": "Bestätige aktuelle Daten vor dem Kauf.",
  "how.cta": "Meine Recherche starten",
  "qc.title": "QC vor dem Kauf verstehen",
  "qc.description": "QC-Fotos und Informationen können helfen, sichtbare Details eines Produkts zu identifizieren, aber sie stellen keine Garantie für Authentizität oder Endqualität dar.",
  "qc.cta": "QC-Ratgeber lesen",
  "shipping.title": "Versandkosten verstehen",
  "shipping.description": "Die Endkosten können von Gewicht, Volumen, Ziel, Dienstleister und gewählter Methode abhängen. Prüfe immer aktuelle Informationen.",
  "shipping.cta": "CSSBuy Versandkosten-Guide ansehen",
  "safety.title": "Sicherer recherchieren",
  "safety.item1": "Link-Ziele überprüfen",
  "safety.item2": "Aktuelle Preise prüfen",
  "safety.item3": "Größen bestätigen",
  "safety.item4": "QC analysieren",
  "safety.item5": "Verkäufer überprüfen",
  "safety.item6": "Passwörter niemals teilen",
  "safety.item7": "Keine Zahlungen an inoffizielle Kontakte",
  "safety.item8": "Versandinformationen bestätigen",
  "safety.cta": "Sicherheitsratgeber öffnen",
  "final.title": "Bereit, deine Recherche zu starten?",
  "final.description": "Nutze CSSBuy Spreadsheet als Ausgangspunkt, erkunde unsere Ratgeber und prüfe aktuelle Informationen, bevor du deine Entscheidung triffst.",
  "final.cta_primary": "CSSBuy Spreadsheet öffnen",
  "final.cta_secondary": "Hauptwebsite besuchen",
  "articles.title": "Neueste Ratgeber & Artikel",
  "articles.read_more": "Mehr lesen",
  "articles.read_time": "Min. Lesezeit",
  "footer.disclaimer": "cssbuybr.skin ist eine unabhängige Informationswebsite und nicht die offizielle CSSBuy-Website.",
  "footer.resources": "CSSBuy Spreadsheet",
  "footer.company": "Unternehmen",
  "footer.languages": "Sprachen",
  "footer.spreadsheet": "Spreadsheet",
  "footer.categories": "Kategorien",
  "footer.guides": "Ratgeber",
  "footer.reviews": "Reviews",
  "footer.shipping": "Versand",
  "footer.qc": "QC",
  "footer.safety": "Sicherheit",
  "footer.faq": "FAQ",
  "footer.about": "Über uns",
  "footer.contact": "Kontakt",
  "footer.privacy": "Datenschutz",
  "footer.terms": "Nutzungsbedingungen",
  "footer.affiliate": "Affiliate-Offenlegung",
  "dropdown.label": "Alle Kategorien",
  "dropdown.placeholder": "Wähle eine Kategorie...",
  "breadcrumbs.home": "Startseite",
  "article.author": "Von",
  "article.updated": "Aktualisiert",
  "article.published": "Veröffentlicht",
  "article.read_time": "Min. Lesezeit",
  "article.table_of_contents": "Inhaltsverzeichnis",
  "article.back_to_home": "Zurück zur Startseite",
  "article.related_articles": "Verwandte Artikel",
  "article.share": "Teilen",
  "nav.products": "Produkte",
  "products.page_title": "CSSBuy Produktverzeichnis",
  "products.page_subtitle": "Durchsuche alle Produkte aus dem CSSBuy Spreadsheet. Klicke auf ein Produkt, um es auf der Hauptseite anzusehen und zu kaufen.",
  "products.search_placeholder": "Produkte suchen...",
  "products.results_count": "Produkte gefunden",
  "products.browse_full_category": "Vollständige Kategorie auf der Hauptseite ansehen",
  "products.no_results": "Keine Produkte gefunden. Versuche eine andere Suche.",
  "products.clear_filters": "Filter löschen",
  "products.cta_title": "Möchtest du mehr Produkte sehen?",
  "products.cta_desc": "Durchsuche das vollständige CSSBuy Spreadsheet mit Tausenden von Produkten, QC-Fotos und aktuellen Links."
};